var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueStopCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stop-circle",
    transform: "translate(-1.2 -1.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    d: "M14.2-.8A15,15,0,0,1,24.807,24.807,15,15,0,0,1,3.593,3.593,14.9,14.9,0,0,1,14.2-.8Zm0,27.876A12.876,12.876,0,1,0,1.324,14.2,12.891,12.891,0,0,0,14.2,27.076Z",
    transform: "translate(2 2.064)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    width: 7,
    height: 7,
    rx: 1,
    transform: "translate(12.7 12.764)",
    fill: "#00246a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStopCircle);
export default __webpack_public_path__ + "static/media/blue-stop-circle.9f604ebe3d00b135c65d819551a8bb63.svg";
export { ForwardRef as ReactComponent };